import { BaseCollection } from './BaseCollection';

export class AggregatedCollection extends BaseCollection {
    fetch(loadMore,
        page = (loadMore ? this.NEXT_DISPLAY_PAGE : 'latest.json'),
        notifications = []) {
        return super.loadData('aggregated', page).then(
            ({ list, next, reachedEnd }) => {
                if (!list) {
                    return { data: [], reachedEnd };
                }

                if (!next) {
                    reachedEnd = true;
                }

                console.warn('Got aggregate page back', list, next, reachedEnd);

                const concatNotifications = notifications.concat(list);
                const filteredData = super.filterData(concatNotifications);
                const dedupedData = super.dedupeData(filteredData);

                if (dedupedData.length >= this.MINIMUM_TO_DISPLAY || reachedEnd) {
                    if (!this.NEXT_DISPLAY_PAGE || (loadMore && !reachedEnd && next)) {
                        this.NEXT_DISPLAY_PAGE = next;
                    }

                    return { data: dedupedData, reachedEnd };
                }

                return this.fetch(loadMore, next, dedupedData);
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/models/collections/AggregatedCollection.js
 **/